import {BaseContainerModel} from '../base-container.model';
import {bl_applet_hdr_RowClass} from '../../dbschema';
import {bl_applet_ext_RowInterface} from '../../dbschema/bl_applet_ext.model';

export class AppletContainerModel extends BaseContainerModel {
  bl_applet_hdr: bl_applet_hdr_RowClass = new bl_applet_hdr_RowClass();
  bl_applet_exts: Array<bl_applet_ext_RowInterface> = [];
}
